import React, {Component} from 'react';
import {connect} from 'react-redux';
import {login} from 'actions/AuthActions';
import {getURL} from '../routes';
import { push } from 'react-router-redux';
import {
  whois
} from 'actions/AuthActions';

const LoginFailMsg = () => (
  <label className="fail-msg">
    - Invaild Mobile or Password, plase try again!
  </label>
);

class Login extends Component {
  constructor(props) {
		super(props);
    this.state = {
      claim: "",
      password: "",
      remember: false,
    };
	}

  componentDidMount() {
    whois()
      .then((response) => {
        this.props.dispatch(push(getURL('/')));
      })
  }

  login = () => {
    let { claim, password, remember } = this.state;

    this.props.dispatch(login(claim, password, remember));
  }

  handleFormChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({
      [name]: value
    })
  }

  render() {
    return (
      <div className="login-form center">
        <form>
          <div className="header">
            Worker System
          </div>

          <input 
            type="text" 
            placeholder="Mobile"
            className="form-control"
            name="claim" 
            value={this.state.claim}
            onChange={this.handleFormChange} 
          />

          <input 
            type="password" 
            placeholder="Password"
            className="form-control"
            name="password"
            value={this.state.password}
            onChange={this.handleFormChange}
          />

          {this.props.fail && <LoginFailMsg />}

          <div className="remember-me-checkbox">
            <input
              type="checkbox"
              name='remember'
              value={this.state.remember}
              onChange={this.handleFormChange}
            />
              Remember me
          </div>
          <div className="text-right">
            <button 
              className="btn btn-primary"
              onClick={this.login} 
              disabled={this.props.loggingIn}
            >
              Login
            </button>
          </div>
        </form>
      </div>
    );
  }
};

export default connect((state) => ({
  fail: state.auth.get('loginFail'),
  loggingIn: state.auth.get('loggingIn'),
}))(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js